import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Typography
} from '@mui/material';

import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

import './link-cards.styles.scss';

function LinkTile({ cardTitle, img, alt, linkTo, handleClick, isSelected, size='small', mediaSx={} }) {
  let width, height, titleHeight, titleVar;
  if (size === 'small') {
    width = '140px';
    height = '80px';
    titleHeight = '40px';
    titleVar = 'subtitle1';
  } else if (size === 'medium') {
    width = '50px';
    height = '105px';
    titleHeight = '50px';
    titleVar = 'h6';
  } else if (size === 'large') {
    width = '200px';
    height = '120px';
    titleHeight = '60px';
    titleVar = 'h6';
  }

  return (
    <Card className='link-card' style={{ height: 'fit-content', minWidth: '70px', border: '2px solid darkgreen', borderRight: isSelected ? '4px solid gold' : '2px solid darkgreen', width: width }}>
      <CardActionArea sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} onClick={() => linkTo.disabled ? '' : handleClick(cardTitle, linkTo)}>
        <CardContent sx={{ minHeight: titleHeight }}>
          <Typography gutterBottom variant={titleVar} component="div">
            {cardTitle}
          </Typography>
        </CardContent>
        
        <CardMedia
          sx={{ height: height, width: '100%', borderTop: '1px solid rgb(200,200,200)', ...mediaSx }}
          image={img}
          title={alt}
        />
      </CardActionArea>
    </Card>
  );
}

function LinkTextCard({ cardTitle, img, alt, linkTo, handleClick, isSecondary, size='small', mediaSx={}, text='' }) {
  return (
    <div className='link-text-card'>
      <LinkTile cardTitle={cardTitle} img={img} alt={alt} linkTo={linkTo} handleClick={handleClick} isSelected={false} isSecondary={isSecondary} size={size} mediaSx={mediaSx} />
      <div className='link-text-card-text'>
        {text.slice(-3) === '.md' ? (
          <MarkdownToJsx
            path={`${process.env.PUBLIC_URL}/markdown/${text}`}
          />
        ) : (
          <p>{text}</p>
        )}
      </div>
    </div>
  );
}

export default function LinkCards({ cardInfoList, handleClick, selected='', isSecondary=false }) {
  return (
    <div className='link-cards-cards-container'>
      {cardInfoList.map((obj, i) => {
        if (isSecondary) {
          return (
            <React.Fragment key={i}>
              {i !== 0 && <hr style={{ width: '75%', borderColor: 'rgba(0,0,0,0.18)' }} />}
              <LinkTextCard key={i} handleClick={handleClick} size='small' {...obj} />
            </React.Fragment>
          );
        } else {
          return <LinkTile key={i} handleClick={handleClick} size='large' isSelected={obj.cardTitle === selected} {...obj} />;
        }
      })}
    </div>
  );
}